import React, { useState, useEffect, Fragment } from 'react';
import MaterialTable from 'material-table';
import { isEmpty, reducerAccumulator } from '@widergy/web-utils/lib/array';
import { UTLabel } from '@widergy/energy-ui';
import { shouldShowErrors } from '@widergy/web-utils/lib/form';

import { inputPropTypes, metaPropTypes } from 'types/formTypes';

import CustomEditField from './components/EditField';
import { columns, tableIcons } from './constants';
import styles from './styles.module.scss';

const CustomTable = ({ input, meta }) => {
  const [rows, setRows] = useState([]);
  const [fieldErrors, setFieldErrors] = useState([]);

  useEffect(() => {
    const newRows = rows.map(row => {
      const rowKeys = Object.keys(row);
      const newRow = {};
      rowKeys.forEach(key => {
        const existColumn = columns.find(_column => _column.field === key);
        if (existColumn) newRow[key] = row[key];
      });
      return newRow;
    });
    input.onChange(newRows);
  }, [rows]);

  const retrieveEmptyFields = data =>
    columns.filter(_column => _column.required && !data[_column.field]).map(column => column.field);

  const handleAddRow = newData =>
    new Promise((resolve, reject) => {
      const emptyFields = retrieveEmptyFields(newData);
      if (isEmpty(emptyFields)) {
        setFieldErrors([]);
        setRows(prevData => {
          const data = [...prevData];
          data.push(newData);
          return data;
        });
        resolve();
      } else {
        setFieldErrors(emptyFields);
        reject();
      }
    });

  const handleEditRow = (newData, oldData) =>
    new Promise((resolve, reject) => {
      if (oldData) {
        const emptyFields = retrieveEmptyFields(newData);
        if (isEmpty(emptyFields)) {
          setFieldErrors([]);
          setRows(prevData => {
            const data = [...prevData];
            data[data.indexOf(oldData)] = newData;
            return data;
          });
          resolve();
        } else {
          setFieldErrors(emptyFields);
          reject();
        }
      } else reject();
    });

  const handleDeleteRow = async oldData =>
    setRows(prevData => {
      const data = [...prevData];
      data.splice(data.indexOf(oldData), 1);
      return data;
    });

  const renderCustomCell = props => <CustomEditField fieldErrors={fieldErrors} {...props} />;

  const totalAmount = rows.map(row => parseInt(row.ingreso, 10)).reduce(reducerAccumulator, 0);

  return (
    <Fragment>
      <MaterialTable
        title=""
        columns={columns}
        data={rows}
        icons={tableIcons}
        localization={{
          header: { actions: 'Acciones' },
          body: {
            addTooltip: 'Agregar',
            deleteTooltip: 'Eliminar',
            editTooltip: 'Editar',
            emptyDataSourceMessage: 'Agrega presionando en el botón +',
            editRow: {
              cancelTooltip: 'Cancelar',
              saveTooltip: 'Confirmar',
              deleteText: 'Estás seguro de eliminar la fila?'
            }
          }
        }}
        options={{ search: false, sorting: false, selection: false, draggable: false, paging: false }}
        editable={{ onRowAdd: handleAddRow, onRowUpdate: handleEditRow, onRowDelete: handleDeleteRow }}
        components={{
          EditField: renderCustomCell
        }}
      />
      {shouldShowErrors(meta) && (
        <UTLabel small error>
          {meta.error}
        </UTLabel>
      )}
      <div className={styles.totalAmount}>
        <UTLabel semibold>{`Total Ingresos $/mes	del	grupo	familiar	conviviente: $ ${totalAmount}`}</UTLabel>
      </div>
    </Fragment>
  );
};

CustomTable.propTypes = {
  input: inputPropTypes,
  meta: metaPropTypes
};

export default CustomTable;
